import { ChangeDetectorRef, Directive, Host, HostListener, Input, Optional } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { EmailPasteNameTargets, EmailPasteOptions, handleEmailPasteEvent } from './email-paste.util';

@Directive({
    selector: '[appEmailPaste]',
})
export class EmailPasteDirective {
    @Input() emailControl: AbstractControl | null;
    @Input() nameControl: AbstractControl | null;
    @Input() firstNameControl: AbstractControl | null;
    @Input() lastNameControl: AbstractControl | null;
    @Input() emailPasteFillOnlyWhenEmpty = true;

    constructor(@Optional() @Host() private changeRef: ChangeDetectorRef) {}

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        if (!this.emailControl) {
            return;
        }

        const nameTargets: EmailPasteNameTargets = {
            name: this.nameControl,
            firstName: this.firstNameControl,
            lastName: this.lastNameControl,
        };
        const options: EmailPasteOptions = {
            fillOnlyWhenEmpty: this.emailPasteFillOnlyWhenEmpty,
        };

        if (handleEmailPasteEvent(event, this.emailControl, nameTargets, options)) {
            this.changeRef?.markForCheck();
        }
    }
}
